<template>
  <div class="modal-job-container">
    <h3>Job Data</h3>
    <div class="modal-job-input-box" v-for="item, index in inputData" :key="index">
      <label class="modal-job-label">{{ item.label }}</label>
      <input data-testid="modal-job-input" :id="item.id" class="modal-job-input" type="text" :value="item.value" @change="this.handleItem($event, index)" :placeholder="item.placeholder" />
    </div>
    <div class="modal-job-buttons">
      <button data-testid="modal-job-cancel-button" class="modal-job-cancel-btn" @click="this.handleCancel">Cancel</button>
      <button id="mj-save-btn" data-testid="modal-job-save-button" class="modal-job-save-btn" @click="this.handleSave">Save</button>
    </div>
  </div>
</template>

<script>
import { useModalStore } from '@/store/ModalStore';
import { useInputStore } from '@/store/InputStore';

export default {
  computed: {
    inputData () {
      return useInputStore().getInputData;
    }
  },
  methods: {
    handleCancel () {
      useModalStore().hideModal();
    },
    handleSave () {
      // needs api call connection with data.
      useModalStore().hideModal();
    },
    handleItem (event, index) {
       if (this.inputData[index].label === 'Job Number') {
        useInputStore().setJobNumber(event.target.value);
      }
      this.inputData[index].value = event.target.value;
    }
  }
};
</script>
<style scoped>
  .modal-job-container {
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
    padding: 2rem;
  }
  .modal-job-input-box {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 3px 0;
  }
  .modal-job-buttons {
    display: flex;
    flex-direction: row;
    padding: 2rem 0;
    justify-content: flex-end;
  }
  .modal-job-input {
    padding: 8px;
    border-radius: 18px;
    background-color: white;
    border: 1px solid #D7D7D7;
  }
  .modal-job-label {
    min-width: 75px;
    font-weight: bold;  
  }
  .modal-job-cancel-btn, .modal-job-save-btn {
    padding: 10px 25px;
    font-weight: 700;
    font-size: .9em;
    text-transform: uppercase;
    cursor: pointer;
    border: none;
  }
  .modal-job-save-btn {
    color: white;
    background-color: var(--nelson-green);
  }
  .modal-job-cancel-btn {
    background-color: #FFFFFF;
  }
</style>